export const visit = (vm, at) => {
vm(require("./availability/it.lyaml"));
vm(require("./typical-response-time/it.lyaml"));
vm(require("./default/it.lyaml"));
at({ "it": { "conversations-internal-schema": { "we-wont-use-this-key-in-the-product-but-this-file-wont-update-with-new-languages-without-a-key": "ok" } } });
};